import React, { useState } from "react";
import "../CSS/AktivitasTenagaKesehatan.css";
import "../CSS/SemuaDataPasienAdmin.css";
import {
  FaStethoscope,
  FaCheckCircle,
  FaFileAlt,
  FaDownload,
  FaTrash,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";

function AktivitasTenagaKesehatan() {
  const navigate = useNavigate();

  // ===== DATA AKTIVITAS SCREENING =====
  const [aktivitasScreening, setAktivitasScreening] = useState([
    {
      id: 1,
      tanggal: "10-01-2025",
      pasien: "Nezuko",
      hasil: "TB Likely",
      confidence: "92%",
      jenisKelamin: "Perempuan",
      umur: 30,
      alamat: "Surakarta",
    },
    {
      id: 2,
      tanggal: "12-01-2025",
      pasien: "Sasuke",
      hasil: "Suspected TB",
      confidence: "68%",
      jenisKelamin: "Laki-laki",
      umur: 25,
      alamat: "Karanganyar",
    },
  ]);

  // ===== REKOMENDASI =====
  const getRekomendasi = (hasil) => {
    switch (hasil) {
      case "TB Likely":
        return "Segera konsultasi dengan dokter paru.";
      case "TB Indication":
        return "Disarankan rujukan ke fasilitas kesehatan.";
      case "Suspected TB":
        return "Perlu pemeriksaan lanjutan.";
      default:
        return "Pemeriksaan rutin disarankan.";
    }
  };

  // ===== DOWNLOAD PDF =====
  const handleDownloadPDF = (data) => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("HASIL SCREENING TBC", 105, 20, { align: "center" });

    doc.setFontSize(11);
    doc.text(`Nama Pasien       : ${data.pasien}`, 20, 40);
    doc.text(`Jenis Kelamin     : ${data.jenisKelamin}`, 20, 48);
    doc.text(`Umur              : ${data.umur} tahun`, 20, 56);
    doc.text(`Alamat            : ${data.alamat}`, 20, 64);
    doc.text(`Tanggal Screening : ${data.tanggal}`, 20, 72);

    doc.line(20, 78, 190, 78);

    doc.text(`Hasil Screening   : ${data.hasil}`, 20, 90);
    doc.text(`Confidence Score  : ${data.confidence}`, 20, 98);
    doc.text(
      `Rekomendasi Sistem: ${getRekomendasi(data.hasil)}`,
      20,
      106,
      { maxWidth: 160 }
    );

    doc.setFontSize(10);
    doc.text(
      "Hasil ini merupakan hasil screening berbasis citra rontgen paru-paru\n" +
        "dan tidak menggantikan diagnosis dokter.",
      20,
      140
    );

    doc.text("© 2025 TibiSmart", 105, 285, { align: "center" });
    doc.save(`Aktivitas_Screening_${data.pasien}.pdf`);
  };

  // ===== HAPUS DATA =====
  const handleDelete = (id) => {
    if (window.confirm("Yakin ingin menghapus data ini?")) {
      setAktivitasScreening(
        aktivitasScreening.filter((item) => item.id !== id)
      );
    }
  };

  return (
    <div className="profile-page">
      <div className="main-contentprofile">
        <div className="content-profile">

          {/* ===== PROFILE CARD ===== */}
          <div className="profile-card">
            <div className="profile-avatar">NK</div>
            <div className="profile-info">
              <h3>Dr. Megumi Fushiguro</h3>
              <p>Dokter Spesialis Paru - RSUD Magetan</p>
              <p className="nip">NIP. 45668989</p>
            </div>
          </div>

          {/* ===== TAB ===== */}
          <div className="tab-section">
            <button
              className="tab"
              onClick={() => navigate("/HalamanDetailTenagaKesehatan")}
            >
              Informasi
            </button>
            <button className="tab active">Aktivitas</button>
          </div>

          {/* ===== STAT CARD ===== */}
          <div className="stats-container">
            <div className="stat-card">
              <div className="icon-wrapper pasien">
                <FaStethoscope />
              </div>
              <div className="stat-info">
                <h2>{aktivitasScreening.length}</h2>
                <p>Screening Dilakukan</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="icon-wrapper terapi">
                <FaCheckCircle />
              </div>
              <div className="stat-info">
                <h2>—</h2>
                <p>Berbasis CNN</p>
              </div>
            </div>
          </div>

          {/* ===== TABLE AKTIVITAS ===== */}
          <div className="table-containerri">
            <table className="table-pasien">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  <th>Pasien</th>
                  <th>Hasil Screening</th>
                  <th>Confidence</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {aktivitasScreening.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.tanggal}</td>
                    <td>{item.pasien}</td>
                    <td>{item.hasil}</td>
                    <td>{item.confidence}</td>
                    <td className="aksi">
                      <button className="btn-detail">
                        <FaFileAlt /> Detail
                      </button>

                      <button
                        className="btn-detail"
                        onClick={() => handleDownloadPDF(item)}
                      >
                        <FaDownload /> PDF
                      </button>

                      <button
                        className="btn-detail btn-hapus"
                        onClick={() => handleDelete(item.id)}
                      >
                        <FaTrash /> Hapus
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <footer className="footerdebar">
            © 2025 TibiSmart.  
            Hasil ini merupakan hasil screening berbasis citra rontgen dan tidak
            menggantikan diagnosis dokter.
          </footer>

        </div>
      </div>
    </div>
  );
}

export default AktivitasTenagaKesehatan;
